export enum StorefrontPermissions {
  CanSeeOrganizationDetail = "storefront:organization:view",
  CanEditOrganization = "storefront:organization:edit",
  CanInviteUsers = "storefront:user:invite",
  CanCreateUsers = "storefront:user:create",
  CanEditUsers = "storefront:user:edit",
  CanDeleteUsers = "storefront:user:delete",
  CanViewUsers = "storefront:user:view",
  CanViewOrders = "storefront:order:view",
  CanChangeOrderStatus = "storefront:order:changestatus",
}

export enum XApiPermissions {
  CanEditOrganization = "xapi:my_organization:edit",
}

export enum VirtoPermissions {
  LoginOnBehalf = "platform:security:loginOnBehalf",
}

// Innovadis custom
export enum CustomPermissions {
  // Innovadis custom: explicit permission alias for checkout order creation.
  CanCreateOrder = "order:create",
  ShowBulkOrder = "order:create",
  ShowEditWishlist = "DKDCustomModule:edit_wishlist",
  ShowInvoiceHistory = "DKDCustomModule:invoice_history",
  ShowOpenOrders = "DKDCustomModule:open_orders",
  ShowOrderHistory = "DKDCustomModule:order_history",
  ShowPowerBI = "DKDCustomModule:view_powerbi",
  ShowPricing = "pricing:read",
  ShowUserManagement = "DKDCustomModule:user_management",
  ShowViewCompanyInformation = "DKDCustomModule:view_company_information",
  ShowWishlist = "DKDCustomModule:view_wishlist",
}
